import React from 'react';

const img404 = require('../assets/images/404.gif');

const NotFound = (props) => {
  return (
    <div className="container text-center">
      <img src={img404} />
    </div>
  );
}

export default NotFound;